/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {createSparkLightningInvoice} from '../api'

export const useMutationCreateSparkLightningInvoice = createReactQueryMutationHook('createSparkLightningInvoice', createSparkLightningInvoice)
